import { UserImageComponent } from '@/landmark/operations/user-list/user-components/user-image.component';
import { DirectoryUser } from '@/models/directory-user.model';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { UserData } from 'src/app/models/user-data.model';
import { genericProfileImg } from 'src/app/services/data/generic-profile';


@Component({
    selector: 'app-user-card',
    imports: [
    CommonModule,
    ButtonModule,
    MenuModule,
    AvatarModule,
    UserImageComponent
],
    template: `
            <div *ngIf="user" class="p-3 border-round shadow-2 flex align-items-center surface-card" [ngClass]="hover ? ' cursor-pointer hover:surface-hover hover:text-primary' : ''" (click)="userClicked.emit(user)">

            <app-user-image [user]="user"></app-user-image>
                <div class="ml-3">
                    <span class="text-900 text-xl font-medium mb-2">{{ getUserDisplayName(user) }}</span>
                    <p class="mt-1 mb-0 text-600 font-medium text-sm">{{ getUserEmail(user) }}</p>
                </div>
                <div *ngIf="menuItems" class="ml-auto">
                    <button pButton pRipple icon="pi pi-ellipsis-v" class="p-button-text p-button-plain p-button-rounded" (click)="menu1.toggle($event)"></button>
                    <p-menu #menu1 [popup]="true" [model]="menuItems"></p-menu>
                </div>
            </div>
  `,
    styles: [
        ``
    ],
    standalone: true
})
export class UserCardComponent {
 @Input() user: UserData | DirectoryUser | null = null;
 @Input() hover: boolean = false;
 @Input() compact: boolean = false;
 @Input() menuItems: MenuItem[] | undefined;
 @Output() userClicked = new EventEmitter<UserData | DirectoryUser>();
 genericPersonImage64: string = genericProfileImg;

 getImage(user: UserData | DirectoryUser) {
  if(user instanceof UserData) {
    return user.profilePicture;
  } else {
    return user.photoUrl;
  }
 }

 getUserDisplayName(user: UserData | DirectoryUser) {
  if(user instanceof UserData) {
    return user.displayName;
  } else {
    return user.DisplayName;
  }
 }

 getUserEmail(user: UserData | DirectoryUser) {
  if(user instanceof UserData) {
    return user.mail;
  } else {
    return user.User;
  }
 }

}
